import styled, { css } from 'styled-components';
import { ActionVariant } from '../components/DiscountCard/DiscountCard';

export const DiscountsPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`;

export const DiscountFiltersSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DiscountFiltersTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const DiscountToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DiscountToolbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-inline-start: auto;
`;

export const CreateOfferPrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 140px;
  height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.blueMain};
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

export const CreateBundleOutlineButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 140px;
  height: 36px;
  padding: 0 16px;
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.blueMain};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

export const CreateOfferPlusIcon = styled.span`
  font-size: 16px;
  line-height: 1;
  font-weight: 700;
`;

export const UploadIconButton = styled.button`
  width: 36px;
  height: 36px;
  border: 1px solid #d7dce3;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const FiltersToolbarButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #d7dce3;
  border-radius: 8px;
  background: #f1f4f6;
  color: ${({ theme }) => theme.colors.black};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

export const FiltersToolbarIcon = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.grey002};

  &:before {
    content: '\\e9c4';
    font-family: 'Icomoon';
  }
`;

export const DiscountFilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const DiscountStockFilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const DiscountStockFilterLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;

export const DiscountFilterIcon = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.grey002};
  font-family: Icomoon;

  &:before {
    content: '\\e904';
  }
`;

export const DiscountStockCheckboxes = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const CreateOfferButtonWrap = styled.div`
  margin-inline-start: auto;
`;

export const DiscountFilterLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.grey002};
  margin-inline-end: 4px;
`;

export const DiscountFilterPill = styled.button<{ $active?: boolean }>`
  border: 1px solid ${({ $active, theme }) => ($active ? theme.colors.blueMain : '#d9dbdf')};
  background: ${({ $active, theme }) => ($active ? '#eef5ff' : theme.colors.white)};
  color: ${({ $active, theme }) => ($active ? theme.colors.blueMain : theme.colors.black)};
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
`;

export const DiscountCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
`;

export const LoadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0 8px;
`;

export const DiscountsLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
`;

export const LoadMoreButton = styled.button`
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.blueMain};
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  min-width: 140px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const DiscountCardWrapper = styled.article`
  border: 1px solid #e6e8ec;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const DiscountCardTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 12px 0;
  gap: 8px;
`;

export const DiscountCardBadges = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const BundleTypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  background: #eef5ff;
  color: ${({ theme }) => theme.colors.blueMain};
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;

export const DiscountPercentBadge = styled.div`
  width: 48px;
  height: 48px;
  background: ${({ theme }) => theme.colors.blueMain};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  clip-path: polygon(
    50% 0%,
    61% 11%,
    75% 5%,
    79% 20%,
    95% 22%,
    88% 36%,
    100% 50%,
    88% 64%,
    95% 78%,
    79% 80%,
    75% 95%,
    61% 89%,
    50% 100%,
    39% 89%,
    25% 95%,
    21% 80%,
    5% 78%,
    12% 64%,
    0% 50%,
    12% 36%,
    5% 22%,
    21% 20%,
    25% 5%,
    39% 11%
  );
`;

export const DiscountCardImageSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px 4px;
  min-height: 120px;
`;

export const DiscountProductImage = styled.img`
  width: 88px;
  height: 120px;
  object-fit: contain;
`;

export const DiscountCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 16px 12px;
`;

export const DiscountDateText = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const DiscountDateIcon = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey002};

  &:before {
    content: '\\e914';
    font-family: 'Icomoon';
  }
`;

export const DiscountProductName = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.35;
`;

export const DiscountProductSpecs = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey002};
  text-transform: uppercase;
`;

export const DiscountPriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 4px;
`;

export const DiscountFinalPrice = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.blueMain};
`;

export const DiscountOriginalPrice = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.redMain};
  text-decoration: line-through;
`;

export const DiscountCardActionsRow = styled.div<{ $singleAction?: boolean }>`
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid #eef0f3;
  margin-top: auto;
`;

export const DiscountActionButton = styled.button<{
  $variant?: ActionVariant;
}>`
  flex: 1;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-transform: capitalize;

  ${({ $variant, theme }) => {
    if ($variant === 'danger') {
      return css`
        border: 1px solid #f5c2c2;
        background: #fdeeee;
        color: ${theme.colors.redMain};
      `;
    }
    return css`
      border: 1px solid ${theme.colors.blueMain};
      background: ${theme.colors.blueMain};
      color: ${theme.colors.white};
    `;
  }}
`;

export const DiscountStatusBadge = styled.span<{ $variant?: string }>`
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  padding: 6px 14px;
  line-height: 1.4;

  ${({ $variant }) => {
    if ( $variant === 'active') {
      return css`
        color: #0a7a35;
        background: #e8f7ed;
      `;
    }
    if ($variant === 'stopped') {
      return css`
        color: #c62828;
        background: #fdeeee;
      `;
    }
    if ($variant === 'completed') {
      return css`
        color: #ffffff;
        background: #31a636;
      `;
    }
    return css`
      color: #0070cd;
      background: #eef5ff;
    `;
  }}
`;

export const DiscountEmptyState = styled.div`
  padding: 48px 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey002};
  font-size: 14px;
`;

export const OffersEmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  min-height: 360px;
  background: #f5f6f8;
  border-radius: 8px;
`;

export const OffersEmptyStateTitle = styled.h2`
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
`;

export const OffersEmptyStateSubtitle = styled.p`
  margin: 0 0 24px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const OffersEmptyStateButton = styled(CreateOfferPrimaryButton)`
  border-radius: 24px;
  min-width: 160px;
  height: 40px;
  justify-content: center;
`;

export const OffersEmptyStateOutlineButton = styled(CreateBundleOutlineButton)`
  border-radius: 24px;
  min-width: 160px;
  height: 40px;
  justify-content: center;
`;

export const OffersEmptyStateActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ModalBodyContent = styled.div`
  padding: 16px 24px;
  box-sizing: border-box;
  width: 100%;

  ${({ $fixedHeight }: { $fixedHeight?: boolean }) =>
    $fixedHeight &&
    `
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  `}
`;

export const ConfirmModalMessage = styled.p`
  margin: 0;
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.black};
`;

export const ModalField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
  flex-shrink: 0;
`;

export const ModalLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;

export const SelectBundleLabel = styled(ModalLabel)`
  display: block;
  margin-bottom: 8px;
`;

export const InlineError = styled.span`
  font-size: 12px;
  color: #e53e3e;
  margin-top: 4px;
`;

export const ModalInput = styled.input`
  border: 1px solid #d9dbdf;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;

export const SelectProductsSearchField = styled(ModalField)`
  width: 100%;
  min-width: 0;
`;

export const ModalSelect = styled.select`
  border: 1px solid #d9dbdf;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
`;

export const SearchResultsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0 8px;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const SelectProductsResultsPanel = styled.div`
  flex: 1;
  min-height: 60vh;
  max-height: 60vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const SelectProductsLoaderWrap = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductSearchResults = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const ProductSearchScrollSentinel = styled.div`
  height: 1px;
  flex-shrink: 0;
`;

export const ProductSearchResultItem = styled.div<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid ${({ $selected, theme }) => ($selected ? theme.colors.blueMain : '#e6e8ec')};
  background: ${({ $selected }) => ($selected ? '#eef5ff' : '#fff')};
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  text-align: start;
  user-select: none;
`;

export const ProductSearchResultMain = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const ProductSearchResultMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ProductSearchResultPrice = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.blueMain};
  font-weight: 600;
`;

export const SelectionToggle = styled.span<{ $selected?: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  color: ${({ $selected, theme }) => ($selected ? theme.colors.white : theme.colors.blueMain)};
  background: ${({ $selected, theme }) => ($selected ? theme.colors.blueMain : '#eef5ff')};
`;

export const CreateDiscountTopRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  align-items: end;
  margin-bottom: 16px;
  flex-shrink: 0;

  ${ModalField} {
    margin-bottom: 0;
    min-width: 0;
  }

  ${ModalInput} {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const DateRangeRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  margin-bottom: 16px;
  flex-shrink: 0;

  ${ModalField} {
    margin-bottom: 0;
    min-width: 0;
  }

  ${ModalInput} {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const OfferTableScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const AdvancedFiltersDateRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  margin-bottom: 0;

  ${ModalField} {
    margin-bottom: 0;
    min-width: 0;
  }

  ${ModalInput} {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const DiscountStatusFilterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
`;

export const DiscountItemTypeFilterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.grey100};
`;

export const OfferTable = styled.div`
  border: 1px solid #e6e8ec;
  border-radius: 8px;
  overflow: hidden;
`;

export const OfferTableHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 0.6fr) minmax(0, 0.5fr) minmax(140px, 1.8fr) 80px;
  gap: 8px;
  padding: 10px 12px;
  background: #f7f8fa;
  font-size: 12px;
  font-weight: 600;

  > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const OfferTableRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 0.6fr) minmax(0, 0.5fr) minmax(140px, 1.8fr) 80px;
  gap: 8px;
  padding: 10px 12px;
  align-items: center;
  border-top: 1px solid #eef0f3;
  font-size: 13px;

  > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const OfferDiscountInputWrap = styled.div`
  display: flex;
  gap: 6px;
  min-width: 0;

  ${ModalInput} {
    flex: 1;
    min-width: 0;
    width: auto;
    box-sizing: border-box;
  }

  ${ModalSelect} {
    flex: 0 0 64px;
    min-width: 64px;
    box-sizing: border-box;
  }
`;

export const InfoBanner = styled.div`
  margin-top: auto;
  padding: 12px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #fff8e6;
  color: #8a6d1f;
`;

export const EditOfferGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  margin-bottom: 12px;

  ${ModalField} {
    margin-bottom: 0;
    min-width: 0;
  }

  ${ModalInput},
  ${ModalSelect} {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const EditOfferDiscountRow = styled.div`
  display: flex;
  gap: 8px;
  min-width: 0;

  ${ModalInput} {
    flex: 1;
    min-width: 0;
  }

  ${ModalSelect} {
    flex: 0 0 72px;
    min-width: 72px;
  }
`;

export const RemoveLineButton = styled.button`
  border: 0;
  background: #fdeeee;
  color: ${({ theme }) => theme.colors.redMain};
  border-radius: 6px;
  width: 32px;
  height: 32px;
  cursor: pointer;
`;

export const extendCreateOfferButtonStyle = css`
  min-width: 148px;
  height: 36px;
  white-space: nowrap;
`;

export const SelectProductsLinkButton = styled.button`
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  background: ${({ theme }) => theme.colors.blueMain};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
`;

export const ShowAllRow = styled.div`
  text-align: center;
  padding: 10px;
  border-top: 1px solid #eef0f3;
  color: ${({ theme }) => theme.colors.blueMain};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`;

export const SelectBundleInput = styled(ModalInput)`
  cursor: pointer;
  margin-bottom: 24px;

  &:hover {
    border-color: ${({ theme }) => theme.colors.blueMain};
  }
`;

export const SelectedBundleHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;

export const SelectedBundleCheck = styled.span`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #22c55e;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
`;

export const BundlePriceDiscountRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  margin-bottom: 16px;
  flex-shrink: 0;

  ${ModalField} {
    margin-bottom: 0;
    min-width: 0;
  }
`;

export const BundleDiscountControls = styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;

  ${ModalInput}, ${ModalSelect} {
    min-width: 0;
  }

  ${ModalSelect} {
    max-width: 90px;
  }
`;

export const ReadOnlyModalInput = styled(ModalInput)`
  background: #f5f6f8;
  color: ${({ theme }) => theme.colors.grey002};
  cursor: not-allowed;
`;

export const BundleInfoPanel = styled.div`
  border: 1px solid #e6e8ec;
  border-radius: 8px;
  padding: 14px 16px;
  background: #fafbfc;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 8px;
  overflow-y: auto;
  max-height: 200px;
`;

export const BundleInfoLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
`;

export const BundleInfoText = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const ClearBundleButton = styled.button`
  margin-inline-start: auto;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.blueMain};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
`;
